import { getEnv } from '../../../environment';

const env = getEnv();

export const routes = {
    "loginState": [
        {
            "label": "Flash Sale",
            "route": "/shop?saleUuid=015be451-043a-445b-8362-57d9568df730",
            "id": "add-ons"
        },
        {
            "label": "MY SUBSCRIPTIONS",
            "route": "/my-subscriptions",
            "id": "my-box",
            "subRoutes": [
                {
                    "label": "Beauty Edit Box",
                    "route": "/my-subscriptions",
                    "id": "beauty-edit-box"
                },
                {
                    "label": "Customize",
                    "route": "/customize",
                    "id": "customize"
                },
                {
                    "label": "View Box",
                    "route": "/my-subscriptions",
                    "id": "my-box"
                }
            ]
        },
        {
            "label": "SHOP",
            "route": "/shop",
            "id": "shop",
            "subRoutes": [
                {
                    "label": "Visit The Shop",
                    "route": "/shop",
                    "id": "visit-shop"
                },
                {
                    "label": "Exclusive Offers",
                    "route": "/exclusive-offers",
                    "id": "exclusive_offers"
                },
                {
                    "label": "Gift",
                    "route": "/gift",
                    "id": "gift"
                },
                {
                    "label": "Flash Sale",
                    "route": "/shop",
                    "id": "edit"
                }
            ]
        },
        {
            "label": "MAGAZINE",
            "route": "/magazine",
            "id": "magazine"
        },
        {
            "label": "COMMUNITY",
            "route": "/",
            "domain": "https://talk.fabfitfun.com",
            "id": "community",
            "subRoutes": [
                {
                    "label": "Forum",
                    "route": "/",
                    "domain": "https://talk.fabfitfun.com",
                    "id": "forum"
                }
            ]
        }
    ],
    "logoutState": [
        {
            "label": "GET THE BOX",
            "id": "get-the-box",
            "route": "/get-the-box/?step=getbox&#getstarted"
        },
        {
            "label": "GIFT",
            "id": "gift",
            "route": "/gift"
        },
        {
            "domain": env.REACT_APP_LOGIN_BASE_URL,
            "id": "login",
            "label": "LOG IN",
            "route": "/"
        }
    ],
    "userProfile": [
        {
            "label": "My Account",
            "route": "/my-account/",
            "id": "my_account"
        },
        {
            "label": "Invoice History",
            "route": "/my-account/invoice-history",
            "id": "invoice_history"
        },
        {
            "label": "Earn $$$",
            "route": "/invite",
            "id": "invite"
        },
        {
            "label": "Send A Starter Box",
            "route": "/invite-friends",
            "id": "invite_friends"
        },
        {
            "label": "Rate & Review",
            "route": "/my-account/rate-and-review",
            "id": "rate_and_review"
        },
        {
            "label": "Personal Survey",
            "route": "/my-account/personal-survey",
            "id": "personal_survey"
        },
        {
            "label": "Manage Email Preferences",
            "route": "/manage-email-preferences/",
            "id": "email_preferences"
        },
        {
            "domain": env.REACT_APP_LOGIN_BASE_URL,
            "id": "account_logout",
            "label": "Log Out",
            "route": "/logout"
        }
    ]
}